import { render, staticRenderFns } from "./MailingsMessages.vue?vue&type=template&id=ea806600&scoped=true&"
import script from "./MailingsMessages.vue?vue&type=script&lang=ts&"
export * from "./MailingsMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea806600",
  null
  
)

export default component.exports